module.exports = __webpack_public_path__ + "img/predictive1.e5f65427.jpg";